import { HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';

export function getAuthHeaders(frontApi=false) {
  if(frontApi) return new HttpHeaders({'x-api-key':'2qYCUKTEFJ6jSvZVcHv5ZxcauMUMhbO33MoTw940'});
  return new HttpHeaders({ 'x-api-key': environment.xApiKey });
}

export function getImportantUpdatesHeaders() {
  let headers = new HttpHeaders();
  const obj = {
    mode:'web',
    umang_id:"",
    old_user_id:'',
    platform:"domestic",
    token: '',
    lang:'en',
    ip_address:"",
    device_id:"",
    tkn: ''
  }
  const umangData =  btoa(JSON.stringify(obj))
  headers = headers.set('x-api-key', '2qYCUKTEFJ6jSvZVcHv5ZxcauMUMhbO33MoTw940');
  headers = headers.set('data', umangData);

  

  return headers;
}

declare var Base64: any;

export function getBannerParams(lang: string, mode = 'web', bannerSize?:any) {
  return new HttpParams()
    .append('mod', mode)
    .append('bannerSize', bannerSize)
    .append('lang', lang)
    .append('bannertype', '1');
}

export function getAllServicesParams(lang: string) {
  return new HttpParams()
    .append('lang', lang)
    .append('os', 'web')
    .append('mod', 'app')
    .append('ldate', '')
    .append('depttype', 'all')
    .append('st', '');
}

export function getHomeServicesParams(lang: string, serviceCardNo = '') {
    return new HttpParams()
    .append('servicecardno', serviceCardNo)
    .append('lang', lang)
    .append('os', 'web')
}

export function getDeptServicesBody(serviceId: string, lang: string) {
  return {
    did: null,
    imei: null,
    hmk: null,
    hmd: null,
    os: null,
    pkg: null,
    ver: null,
    tkn: null,
    rot: null,
    mod: 'web',
    mcc: null,
    mnc: null,
    lac: null,
    clid: null,
    acc: null,
    lat: '1588934421533',
    lon: null,
    peml: null,
    lang: lang,
    aadhr: null,
    mno: null,
    sid: serviceId || '10',
  };
}

export function getEncDecBody(payload:any, changeUrl?:any){
 return Base64.encode((JSON.stringify({
    payload: payload,
    url: changeUrl || environment.API_BASE_URL,
    bearerToken: environment.deptBaseBearerToken,
    header: 'UmangX'
  })));
}

function getCommonBody(lang?:any) {
  return {
    aadhr: '',
    wt: '',
    tkn: '',
    hmd: '',
    os: 'web',
    mcc: '',
    imei: '',
    pkg: '',
    clid: '',
    lat: '',
    lon: '',
    hmk: '',
    ver: '',
    mnc: '',
    acc: '',
    lac: '',
    peml: '',
    did: '',
    imsi: '',
    mod: 'web',
    lang: lang,
    rot: '',
  };
}

export function getAppKeyBody(searchKeyword: any, lang:any) {
  return {
    ...getCommonBody(lang),
    q: searchKeyword,
    fq: '',
  };
}

export function getAppLangBody(
  searchKeyword: any,
  catid: any,
  st: any,
  isStateNegative: any,
  lang:any
) {
  const stNew = st && st.split('-')[1];
  const body = {
    ...getCommonBody(lang),
    q: searchKeyword,
    catid: catid ? catid : '*',
    st: st ? st : '*',
    fq: `(cgid:${catid ? catid : '*'} AND ${
      isStateNegative ? '-' : ''
    }state:${isStateNegative ? stNew : st ? st : '*'})`,
  };
  return body;
}